import { type FC } from 'react';
import { Box, Button, Tooltip } from '@chakra-ui/react';
import { Event } from '../types';
import { useAppInsights } from '../hooks/useAppInsights';
import { getEventFactory } from '../utils/get-event-factory';
import { ReactComponent as LiveIcon } from '../assets/svg/LiveIcon.svg';
import { translate } from '../constants/translation';

export interface Props {
  switchToLiveview: () => void;
  operation: string;
}

const LiveViewButton: FC<Props> = ({ switchToLiveview, operation }) => {
  const appInsights = useAppInsights();
  const navigateToLiveView = (): void => {
    const event = getEventFactory(Event.LiveViewButtonClicked)(operation);
    appInsights.trackAnalyticsEvent(event);
    switchToLiveview();
  };

  return (
    <Box>
      <Tooltip label={translate('LIVE_VIEW')}>
        <Button variant="secondary" aria-label="Live View" leftIcon={<LiveIcon />} onClick={navigateToLiveView}>
          {translate('LIVE')}
        </Button>
      </Tooltip>
    </Box>
  );
};

export default LiveViewButton;
